
  import { dasherize } from 'inflected';
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters('modal', { modal: 'getCurrentModal', disableClickToClose: 'getDisableClickToClose' }),
      modalPath () {
        return `base-modal-list-${dasherize(this.modal.id).toLowerCase()}`;
      }
    },
    watch: {
      modal () {
        this.refresh();
      }
    },
    mounted () {
      this.refresh();
    },
    methods: {
      firstFocusable () {
        return this.$el.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])')[0];
      },
      closeModal () {
        if (this.disableClickToClose) return;

        if (this.modal) {
          this.$store.commit('modal/REMOVE_MODAL', this.modal.id);
        }
      },
      focusFirst () {
        const focusable = this.firstFocusable();
        if (focusable) {
          focusable.focus();
        }
      },
      keyHandler (event) {
        if (event.key === 'Escape') {
          this.closeModal();
        }
        if (event.target.closest('.modal-content')) {
          return;
        }
        if (event.key === 'Backspace') {
          this.closeModal();
        }
      },
      refresh () {
        if (this.modal) {
          window.addEventListener('keydown', this.keyHandler);
          this.$nextTick(() => this.focusFirst());
        } else {
          window.removeEventListener('keydown');
        }
        document.body.style.overflowY = this.modal ? 'hidden' : null;
      }
    }
  };
